angular.module('elfium').controller('contactListController', ['$scope', '$filter', 'contactService', 'elfiumToastrService', 'elfiumListFilterFactory',
    function ($scope, $filter, contactService, elfiumToastrService, elfiumListFilterFactory) {
        var that = this;
        $scope.filters = {
            firma: {}
        };
        $scope.selectedSort = {};
        that.getContacts = function () {
        	contactService.getContacts().then(function (contacts) {
	            that.listFilter = new elfiumListFilterFactory($scope, contacts, $scope.filters, 'contacts');
	        }, elfiumToastrService.error);
        };
        $scope.openContactDetailModal = function (contactId) {
        	contactService.openContactDetailModal(contactId).then(that.getContacts);
        };
        that.getContacts();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/contact/contactListController.ts